import React from 'react';
import { StyledCloseBtn } from './styled';
import { CloseOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { removeDimension } from '@store/trends/base/actions';
import { dimensionsSelector } from '@store/trends/base/selectors';
import { DIMENSION_LIMIT } from '@store/trends/base/reducer';

function RemoveDimension({ dimension, disabled = false }) {
  const dispatch = useDispatch();
  const selectedDimensions = useSelector(dimensionsSelector);

  const handleClose = () => {
    if(selectedDimensions.length > DIMENSION_LIMIT.min ) {
      dispatch(removeDimension(dimension));
    } else {
      message.warning(`Reached minimum limit of ${DIMENSION_LIMIT.min}`);
    }
  };

  return (
    <StyledCloseBtn
      className="remove-dimension-btn"
      type="text" icon={<CloseOutlined />}
      onClick={handleClose}
      size="small"
      disabled={disabled}
    />
    );
}

export default RemoveDimension;
